import ApiService from '../apiservice'

export default class AreaAtuacaoService extends ApiService {

  constructor() {
    super('/areaAtuacao')
  }

  cadastrarAreaAtuacao(area) {
    return this.post('/',area);
  }

  listarAreaAtuacao(empresa) {
    return this.get(`?empresa=${empresa}`);
  }

  consultarAreaAtuacao(codigo) {
    return this.get(`/${codigo}`);
  }

  alterarAreaAtuacao(area) {
    return this.put(`/${area.codigo}`,area);
  }

  excluirAreaAtuacao(codigo) {
    return this.delete(`/${codigo}`);
  }
}